module.exports = __webpack_public_path__ + "media/images/favicon/favicon-192-5f8f5fc848c5db0bd1d0b340dd119cff.png";